module.exports = __webpack_public_path__ + "static/media/trashIcon.2c903603.svg";